module.exports = "https://web-assets.ifttt.com/packs/media/docs/example_badges-2e6fb79e.jpg";